exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.name-min-height-error[data-v-ea7b9ede] {\n  min-height: 100px;\n}\n.price-min-height-error[data-v-ea7b9ede] {\n  min-height: 75px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-ea7b9ede","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventory/extras/ExtraForm.vue
// module id = 1528
// module chunks = 0